import { AppDispatch } from "src/features";
import { actionCreators } from "../reducers/payOnlyFlags";

export const showFeedback = () => {
    return (dispatch: AppDispatch) => {
        window.setTimeout(() => dispatch(actionCreators.setShowFeedback(true)), 3000);
    };
};
